import { render, staticRenderFns } from "./PechatLogo.vue?vue&type=template&id=338226a2"
import script from "./PechatLogo.vue?vue&type=script&lang=js"
export * from "./PechatLogo.vue?vue&type=script&lang=js"
import style0 from "./PechatLogo.vue?vue&type=style&index=0&id=338226a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports